import { Enum } from "./enum.class";
import EnumItem from "./enumItem.class";

/**
 * Enum de tipos de formulário
 * Representa os tipos de formulário disponíveis no sistema
 */
class TipoFormularioEnum extends Enum {
    constructor() {
        super();
        this.PROCESSO_ELEGALIZE = new TipoFormularioEnumItem(1, 'PROCESSO_ELEGALIZE', 'eLegalize');
        this.TAREFA_CLIENTE = new TipoFormularioEnumItem(2, 'TAREFA_CLIENTE', 'Tarefas do Cliente');
    }
}

/**
 * Item do enum de tipo de formulário
 * @extends EnumItem
 */
class TipoFormularioEnumItem extends EnumItem {
    /**
     * @param {number} id - ID do tipo de formulário
     * @param {string} key - Chave do tipo
     * @param {string} origem - Nome de exibição da origem
     */
    constructor(id, key, origem) {
        super(id, key);
        this.origem = origem;
    }

    /**
     * Retorna o nome de exibição da origem
     * @returns {string} Nome da origem
     */
    getOrigem() {
        return this.origem;
    }
}

export const tipoFormularioEnum = new TipoFormularioEnum();
